<template>
    <section class="mt-56 dashboard-brand">
        <h3 class="h3 cabinet-section__dashboard-title">Бренды</h3>

        <div v-if="loading">Loading...</div>

        <div v-else-if="errors.brandsStats">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="loadingBrandsStats"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <div
            v-else-if="!brandsStats.length"
            class="d-flex flex-column flex-md-row align-items-center"
        >
            <img
                src="/img/icons/empty-goods.svg"
                class="dashboard-empty__img dashboard-empty__img--goods ofi"
            />
            <div
                class="dashboard-empty__descr dashboard-empty__descr--goods text-center text-md-left mt-4 mt-md-0"
            >
                <div class="dashboard-empty__title">
                    У вас пока что нет ни одного бренда.
                </div>
                <div class="mt-16">
                    <router-link
                        :to="{ name: 'SupplierSettings' }"
                        tag="button"
                        class="cabinet-btn  cabinet-btn--add cabinet-btn--add-white"
                        >Добавить бренд</router-link
                    >
                </div>
            </div>
        </div>

        <div v-else class="dashboard-scrollable__wrap-brand">
            <div class="dashboard-scrollable__content-brand">
                <div class="d-flex flex-lg-wrap dashboard-brand__row">
                    <div
                        v-for="brand in brandsStats"
                        :key="brand.BrandID"
                        class="dashboard-brand__card"
                    >
                        <div class="dashboard-brand__content">
                            <a href="javascript:void(0)" class="app-link">
                                <img
                                    :src="brand.logo"
                                    :alt="brand.BrandName"
                                    class="dashboard-brand__img ofi"
                                />
                                <div class="dashboard-brand__title">
                                    {{ brand.BrandName }}
                                </div>
                            </a>
                            <div class="dashboard-brand__count">
                                {{ getFormattedNum(brand.subscribers_count) }}
                                <span>
                                    {{
                                        getNounByNum(brand.subscribers_count, [
                                            'подписчик',
                                            'подписчика',
                                            'подписчиков'
                                        ])
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /dashboard-scrollable__content -->
        </div>
        <!-- /dashboard-scrollable__wrap -->
    </section>
</template>

<script>
import getFormattedNum from '@/utils/getFormattedNum'
import getNounByNum from '@/utils/getNounByNum'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'BrandsStats',
    data() {
        return {
            loading: true
        }
    },
    computed: {
        ...mapState('supplierStats', ['brandsStats', 'errors'])
    },
    async mounted() {
        await this.getBrandsStats()
        this.loading = false
    },
    methods: {
        ...mapActions('supplierStats', ['getBrandsStats']),
        getFormattedNum(num) {
            return getFormattedNum(num)
        },
        getNounByNum(num, titles) {
            return getNounByNum(num, titles)
        },
        async loadingBrandsStats() {
            this.loading = true
            await this.getBrandsStats()
            this.loading = false
        }
    }
}
</script>
